import { RespuestaPrimerNivel } from './respuesta-primer-nivel'
import { JsonConverter } from '../JsonConverter'
import { RespuestaSecundaria } from 'app/dominio/respuesta-secundaria'

export class PreguntaSecundaria implements JsonConverter {

  private _id: string
  private _texto: string
  private _indice: number
  private _respuestas: RespuestaSecundaria[]
  private _respuestaSeleccionada: string
  private _textoRespuestaSeleccionada : string

  constructor (id: string, texto: string, respuestas: RespuestaSecundaria[]
  ) {
    this._id = id
    this._texto = texto
    this._respuestas = respuestas
    this._respuestaSeleccionada = ''
    this._textoRespuestaSeleccionada
  }

  get id(): string {
    return this._id
  }

  get texto(): string {
    return this._texto
  }

  get respuestaSeleccionada(): string {
    return this._respuestaSeleccionada
  }
  
  set respuestaSeleccionada(r) {
    this._respuestaSeleccionada = r
  }

  set textoRespuestaSeleccionada(texto) {
    this._textoRespuestaSeleccionada = texto
  }

  get textoRespuestaSeleccionada(): string {
    return this._textoRespuestaSeleccionada
  }

  get respuestas(): RespuestaSecundaria[] {
    return this._respuestas
  }

  toJson(): any {
    return {
      id: this.id,
      texto: this.texto,
      respuestas: this.respuestas.map( r => r.toJson()),
      textoRespuestaSeleccionada: this.textoRespuestaSeleccionada
    }
  }

  toJsonD(): any {
    return {
      id: this.id,
      idRespuesta: this._respuestaSeleccionada
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dominio/pregunta-secundaria.ts